module.exports = __webpack_public_path__ + "29da64ef6aca41d8c7ce1053ae7ecc94.png";